import {TaskType} from "~~/package/mapper/learning/model/TaskType";
import Model from "~~/package/mapper/Model";
import {createModel} from "~~/package/utils/ModelUtil";
import {LangType} from "~~/package/mapper/learning/model/LangType";

export class LevelAssessmentResultModel extends Model {
    constructor(
        public taskId: number = 0,
        public status: string = "IN_CORRECT", // CORRECT, IN_CORRECT
        public level: number = 0,
        public type: TaskType = TaskType.CODE,
        public selfCodingAnswer: string = "",
        public submissionAnswer: string[] = [],
        public question: string = "",
        public multipleChoiceQuestion: string[] = [],
        public langType: string = LangType.PYTHON,

        public description: string = "", // for sample
    ) {
        super();
    }

    public static create(model: Partial<LevelAssessmentResultModel>): LevelAssessmentResultModel {
        return createModel<LevelAssessmentResultModel>(LevelAssessmentResultModel, {
            ...model
        });
    }
}